import {useTranslation} from 'react-i18next';
import {useState} from 'react';
import Btn from '../../../component/button/btn/Btn';
import * as css from './style.css';
import * as cardCss from './card/card.css';
import {useSelector} from 'react-redux';

interface ActionButtonsProps {
    confirmUrl?: string;
    maybeUrl?: string;
    cancelUrl?: string;
    onButtonClick: (token: string | undefined) => void;
    selectedTickets?: number;
    ticketsAmount?: number;
}

function ActionButtons({
    confirmUrl,
    maybeUrl,
    cancelUrl,
    onButtonClick,
    selectedTickets = 0,
    ticketsAmount = 0
}: ActionButtonsProps) {
    const {t} = useTranslation('suspendedConfirmation');
    const [clickedButton, setClickedButton] = useState<string | null>(null);

    const handleButtonClick = (buttonType: string, url?: string) => {
        setClickedButton(buttonType);
        onButtonClick(url);
    };

    const isButtonClicked = (buttonType: string) => clickedButton === buttonType;
    const isAnyButtonClicked = clickedButton !== null;
    const suspendedConfirmationXHR=useSelector((s:any) => s.event.suspendedConfirmationXHR);

    // Show only confirm button if selected tickets count is less than total tickets amount
    const showOnlyConfirmButton = selectedTickets < ticketsAmount;
    const showOnlyCancelButton = selectedTickets === 0;

    return (
        <>
            <cardCss.footer style={{marginBottom: '42px'}}>
                {t('arrivalConfirmation')}
            </cardCss.footer>
            <css.buttonRow className={'decisionScreen'}>
                {!showOnlyCancelButton && (<Btn
                    onClick={() => handleButtonClick('confirm', confirmUrl)}
                    className={isButtonClicked('confirm') ? suspendedConfirmationXHR : ''}
                    disabled={isAnyButtonClicked}
                >
                    {t('willCome')}
                </Btn>)}
                {(!showOnlyConfirmButton || showOnlyCancelButton) && (
                    <>
                        {!showOnlyCancelButton && ( <Btn
                            onClick={() => handleButtonClick('maybe', maybeUrl)}
                            className={`white ${isButtonClicked('maybe') ? suspendedConfirmationXHR : ''}`}
                            disabled={isAnyButtonClicked}
                        >
                            {t('maybe')}
                        </Btn>)
                        }
                        <Btn
                            onClick={() => handleButtonClick('cancel', cancelUrl)}
                            className={`white ${isButtonClicked('cancel') ? suspendedConfirmationXHR : ''}`}
                            disabled={isAnyButtonClicked}
                        >
                            {t('wontCome')}
                        </Btn>
                    </>
                )}
            </css.buttonRow>
        </>
    );
}

export default ActionButtons;
